import { render, staticRenderFns } from "./configGiftTks.vue?vue&type=template&id=b24d7ea4&"
import script from "./configGiftTks.vue?vue&type=script&lang=js&"
export * from "./configGiftTks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports